module.exports = __webpack_public_path__ + "media/icons/audiobook@2x-eb0213fd.png";